// @ts-nocheck
// AI ranking helper — ranks pillars by relevance for a given parent.

import { PILLARS } from './pillars';

export function rankPillars(parent) {
  if (!parent) return PILLARS.map((p) => ({ ...p, relevance: 0, reason: "" }));
  return PILLARS
    .map((p) => {
      const hits = (p.ranks || []).filter((t) => parent.tags.includes(t));
      const triggered = parent.demosTriggered.includes(p.id);
      const baseScore = hits.length * 30 + (triggered ? -20 : 0);
      const noise = (p.id.charCodeAt(0) % 7);
      const relevance = Math.max(0, Math.min(99, baseScore + noise + 28));
      let reason;
      if (triggered) reason = "Already sent — follow up";
      else if (hits.length >= 2) reason = `Matches: ${hits.slice(0, 2).join(" + ")}`;
      else if (hits.length === 1) reason = `Matches: ${hits[0]}`;
      else reason = "Foundational — always relevant";
      return { ...p, relevance, hits: hits.length, triggered, reason };
    })
    .sort((a, b) => b.relevance - a.relevance);
}
